import { Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { useHealthcareServices } from 'src/careflow/ph-core/fhir-client/fhir-react';
import Label from 'src/components/Label';
import DataTable, { DataTableColumn } from 'src/components/table/DataTable';
import fhirSystem from 'src/ccm/fhir/system';
import ProgramsToolbar from './ProgramsToolbar';

const columns: DataTableColumn[] = [
  {
    header: 'Plan Name',
    field: 'name',
  },
  {
    header: 'Status',
    field: 'active',
    render(active = true) {
      return <Label color={active ? 'success' : 'info'}>{active ? 'Active' : 'Inactive'}</Label>;
    },
  },
];

export default function ProgramsTable() {
  const navigate = useNavigate();
  const { lob = '' } = useParams();
  const [programs] = useHealthcareServices({
    filter: {
      identifier: fhirSystem.program.withId(lob).forCode(''),
    },
  });

  return (
    <div>
      <ProgramsToolbar />

      {programs.length ? (
        <DataTable
          selectable
          clickeable
          columns={columns}
          data={programs}
          onItemEdit={(item) => navigate(`${item.id}/edit`)}
          onItemClick={(item) => {
            if (item.id) {
              navigate(item.id);
            }
          }}
          sx={{ m: 2 }}
        />
      ) : (
        <Alert severity="info" sx={{ m: 2 }}>
          No programs found
        </Alert>
      )}
    </div>
  );
}
